import React from 'react';
import { Monitor, Database, Linkedin } from 'lucide-react';

export default function Settings({ darkMode, toggleDarkMode }) {
    return (
        <div className="max-w-2xl mx-auto space-y-8">
            <div>
                <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">Settings</h2>
                <p className="text-slate-500 dark:text-slate-400">Manage your preferences and system configuration</p>
            </div>

            <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden dark:bg-slate-800 dark:border-slate-700">
                <div className="p-6 border-b border-slate-100 dark:border-slate-700">
                    <h3 className="font-semibold text-slate-900 dark:text-slate-100 flex items-center gap-2">
                        <Monitor className="w-5 h-5 text-slate-400" /> Appearance
                    </h3>
                </div>

                <div className="p-6 flex items-center justify-between">
                    <div>
                        <p className="font-medium text-slate-700 dark:text-slate-200">Dark Mode</p>
                        <p className="text-sm text-slate-500 dark:text-slate-400">Toggle between light and dark themes</p>
                    </div>

                    <button
                        onClick={toggleDarkMode}
                        className="relative inline-flex h-6 w-11 items-center rounded-full bg-slate-200 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 dark:bg-slate-600"
                    >
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${darkMode ? 'translate-x-6' : 'translate-x-1'}`} />
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden dark:bg-slate-800 dark:border-slate-700">
                <div className="p-6 border-b border-slate-100 dark:border-slate-700">
                    <h3 className="font-semibold text-slate-900 dark:text-slate-100 flex items-center gap-2">
                        <Database className="w-5 h-5 text-slate-400" /> Database
                    </h3>
                </div>
                <div className="p-6 space-y-4">
                    <div className="flex justify-between items-center">
                        <span className="text-slate-600 dark:text-slate-300">Vector Store Status</span>
                        <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full dark:bg-green-900/30 dark:text-green-400">Connected</span>
                    </div>
                    <div className="flex justify-between items-center">
                        <span className="text-slate-600 dark:text-slate-300">Metadata Store</span>
                        <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full dark:bg-green-900/30 dark:text-green-400">Connected</span>
                    </div>
                </div>
                <div className="bg-slate-50 p-4 border-t border-slate-100 dark:bg-slate-800/50 dark:border-slate-700">
                    <button className="text-sm text-red-600 hover:text-red-700 font-medium">Clear Database Cache</button>
                </div>
            </div>

            <LinkedInSettings />
        </div>
    );
}

function LinkedInSettings() {
    const [instructions, setInstructions] = React.useState(() => {
        return localStorage.getItem('linkedin_custom_instructions') || "";
    });

    const handleChange = (e) => {
        const val = e.target.value;
        setInstructions(val);
        localStorage.setItem('linkedin_custom_instructions', val);
    };

    return (
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden dark:bg-slate-800 dark:border-slate-700">
            <div className="p-6 border-b border-slate-100 dark:border-slate-700">
                <h3 className="font-semibold text-slate-900 dark:text-slate-100 flex items-center gap-2">
                    <div className="bg-white p-1.5 rounded-lg shadow-sm">
                        <Linkedin className="w-5 h-5 text-[#0077b5]" />
                    </div>
                    LinkedIn Customizations
                </h3>
            </div>
            <div className="p-6">
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    Custom Instructions for AI Generator
                </label>
                <p className="text-sm text-slate-500 mb-3">
                    Add specific rules for the AI (e.g., "Use 3 hashtags", "No emojis", "Formal tone").
                </p>
                <textarea
                    value={instructions}
                    onChange={handleChange}
                    placeholder="e.g. Always include #Hiring #Remote. Keep the tone very casual."
                    className="w-full h-32 p-3 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-[#0077b5] outline-none resize-none"
                />
            </div>
        </div>
    );
}
